import React, { Component } from 'react'
import { buildTitle } from '../../components/UserProfile'
import { Row, Col } from 'react-flexbox-grid'
import RBButton from '../../controls/RBButton'
import CollapsibleSection from '../../controls/CollapsibleSection'
import PasswordField from '../../controls/PasswordField'
import { localize } from '../../util/Localizer'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import { PassTooltip } from '../../widgets/common/Tooltip'
import { connect } from 'react-redux'
import { updateUser } from '../../redux/actions/userProfileActions'
import { push } from 'connected-react-router'
import { injectIntl } from 'react-intl'
import Tooltip from '../../controls/Tooltip'
import { Colors } from '../../theme'

class ChangePassword extends Component {
  constructor (props) {
    super(props)
    this.checkEnter = this.checkEnter.bind(this)
    this.enterSave = this.enterSave.bind(this)
    this.validate = this.validate.bind(this)
    this.redirect = this.redirect.bind(this)
    this.saveInfo = this.saveInfo.bind(this)
    this.reset = this.reset.bind(this)
    this.state = {
      ...props.value,
      password: '',
      newPass: '',
      newPassConfirm: '',
      username: props.username
    }
    this.baseState = this.state
    this.overRideDisabledButton = false
  }

  componentDidMount () {
    this.reset()
  }

  reset () {
    const base = this.baseState
    this.setState({ password: base.password })
  }

  redirect () {
    window.location.reload()
  }

  saveInfo () {
    const profileUpdate = {
      username: this.state.username,
      currentpassword: this.state.password,
      newPassword: this.state.newPass,
      confirmNewPassword: this.state.newPassConfirm
    }

    this.props.updateUser(profileUpdate, (data) => {
      this.props.saveComplete(data)
    }, (data) => {
      this.props.errorOnSave(data)
    })
  }

  checkEnter (event) {
    const code = (event.keyCode ? event.keyCode : event.which)
    if (code === 13) {
      this.setState({ enterSave: true }, this.validate)
    }
  }

  validate () {
    const state = this.state
    const newState = {}
    if ((state.newPass.length !== 0 && state.newPass.length < 6) || (state.newPass.length !== 0 && state.newPass.length > 15)) {
      newState.invalidPassLength = localize('pages.userProfile.invalidPassLengthError')
    } else {
      newState.invalidPassLength = null
    }

    // check for matches in pass, if matches reset error state
    if (state.newPassConfirm.length !== 0 && state.newPass !== state.newPassConfirm && !state.invalidPassLength) {
      newState.confirmPassError = localize('pages.userProfile.confirmPassError')
    } else {
      newState.confirmPassError = null
    }

    if (state.newPass.length !== 0 && state.newPassConfirm.length === 0 && !state.invalidPassLength) {
      newState.noConfirmPass = localize('pages.userProfile.noConfirmPass')
    } else {
      newState.noConfirmPass = null
    }

    this.setState(newState, this.enterSave)
  }

  enterSave () {
    if (this.state.enterSave) {
      this.setState({ enterSave: false })
      if (!this.disableButton()) {
        this.saveInfo()
      }
    }
  }

  disableButton () {
    const s = this.state

    if (!s.password || !s.newPass || !s.newPassConfirm) {
      return true
    }

    return !(!s.invalidPassLength &&
      !s.confirmPassError &&
      !s.noConfirmPass)
  }
  render () {
    const values = this.state
    const toolTip = PassTooltip()
    return (
      <div>
        <CollapsibleSection
          id='password'
          showMuiBorder={false}
          isProfile={this.props.isProfile}
          heading={buildTitle('pages.userProfile.title.password', 'pages.userProfile.subtitle.password')}
          expanded={this.props.expanded}
          onExpanded={(key, expanded) => this.props.onExpanded(expanded)}>
          <Row>
            <Col xs={11} md={6}>
              <br />
              <PasswordField
                id='password'
                type='password'
                fullWidth
                floatingLabelText={localize('pages.userProfile.currentPassword')}
                value={values.password}
                onChange={(e, password) => this.setState({ password }, this.validate)}
                onKeyPress={this.checkEnter}
                onBlur={this.validate}
                errorText={values.currentPassError}
              />
              <div className='tooltipInput'>
                <PasswordField
                  id='newPass'
                  type='password'
                  fullWidth
                  floatingLabelText={localize('pages.userProfile.newPassword')}
                  value={values.newPass}
                  onChange={(e, newPass) => this.setState({ newPass }, this.validate)}
                  onKeyPress={this.checkEnter}
                  onBlur={this.validate}
                  errorText={values.invalidPassLength ? values.invalidPassLength : values.confirmPassError}
                  adornment={
                    <Tooltip title={toolTip} placement="right-end">
                      <IconButton tabIndex={-1}>
                        <Icon style={{ color: Colors.Palette.primaryTextColor }}>info</Icon>
                      </IconButton>
                    </Tooltip>
                  }
                />

              </div>
              <PasswordField
                id='newPassConfirm'
                type='password'
                fullWidth
                floatingLabelText={localize('pages.userProfile.confirmPassword')}
                value={values.newPassConfirm}
                onChange={(e, newPassConfirm) => this.setState({ newPassConfirm })}
                onKeyPress={this.checkEnter}
                onBlur={this.validate}
                errorText={values.noConfirmPass ? values.noConfirmPass : values.confirmPassError}
              />
            </Col>
          </Row>
          <div className='buttonContainer fltRight'>
            <RBButton
              variant='outlined'
              id='cancelBtn'
              label={localize('common.cancel')}
              onClick={this.redirect} />
            <RBButton
              variant='contained'
              id='saveBtn'
              label={localize('common.saveUpdates')}
              primary
              onClick={this.saveInfo}
              disabled={this.disableButton()}
              loading={this.props.pageLoading}
            />
          </div>
        </CollapsibleSection>
        <hr />
      </div>
    )
  }
}
function mapStateToProps (state, ownProps) {
  return Object.assign({}, ownProps, {
    pageLoading: state.UserProfileReducers.isFetching
  })
}
const ConnectedChangePassword = connect(mapStateToProps, { updateUser, push })(injectIntl(ChangePassword))
export default ConnectedChangePassword



// WEBPACK FOOTER //
// ./src/widgets/userProfile/ChangePassword.js